var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e354a19c5db19039a1bb99605ca2e91566d7bf19"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["react@eprezto"]={id:"e354a19c5db19039a1bb99605ca2e91566d7bf19"};
      